import React from 'react'
import axios from 'axios'
import { businessApiURL, getCountryCode, getLanguageCode, getToken } from '../..'

export async function updateCustomer(primary) {
  console.log(primary)
  const body = {
    apiParam: 'company',
    locations: primary,
  }
  try {
    const res = await axios.post(
      `${businessApiURL}/api/secure/bc/customer/details/update?languageCode=${getLanguageCode()}&countryCode=${getCountryCode()}`,
      body,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      },
    )
    return res
  } catch (err) {
    console.log(err)
    return err
  }
}

export async function updateCompany(companyName) {
  const body = {
    apiParam: 'company',
    companyName: companyName,
  }
  try {
    const res = await axios.post(
      `${businessApiURL}/api/secure/bc/customer/details/update?languageCode=${getLanguageCode()}&countryCode=${getCountryCode()}`,
      body,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      },
    )
    return res
  } catch (err) {
    console.log(err)
    return err
  }
}

export async function updateBillingDetails(name, email, vatNumber) {
  const body = {
    apiParam: 'company',
    billingDetails: {
      billingAddress: {
        city: 'Gurgaon',
        country: 'India',
        countryCode: 'in',
      },
      vatNumber: vatNumber,
      attnName: name,
      attnEmailId: email,
    },
  }
  try {
    const res = await axios.post(
      `${businessApiURL}/api/secure/bc/customer/details/update?languageCode=${getLanguageCode()}&countryCode=${getCountryCode()}`,
      body,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      },
    )
    return res
  } catch (err) {
    console.log(err)
    return err
  }
}
